/*
 * @Author: etong
 * @Date: 2021-10-20 14:22:52
 * @LastEditTime: 2023-07-19 14:13:01
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @Description:
 * @FilePath: \oak\src\store\modules\routerMap\views\distribution.js
 * Think first, Program later
 */
// 分销管理
const map = {
  // 分销管理
  sellerList: () => import('@/views/distribution/SellerList'), // 分销客户一览
  sellerRelationList: () => import('@/views/distribution/SellerRelationList'), // 业务员关系表
  companyInfoMaintain: () => import('@/views/distribution/CompanyInfoMaintain'), // 公司信息维护
  salesStatistics: () => import('@/views/distribution/SalesStatistics'), // 分销销售统计
  brandSalesTotal: () => import('@/views/distribution/BrandSalesTotal'), // 品牌销售额统计
  distributionOrderList: () =>
     import('@/views/distribution/DistributionOrderList'), // 分销下单|订单列表
  // distributionOrderDetail: () =>
  //   import("@/views/distribution/DistributionOrderDetail"), // 分销下单手工建单
  customBusinessGroup: () => import('@/views/distribution/CustomBusinessGroup'), // 自定义客商分组
  taoDistributionCustomerManagement: () =>
     import('@/views/distribution/TaoDistributionCustomerManagement'), // 淘分销客户管理
  rebateActivityCreation: () =>
     import('@/views/distribution/RebateActivityCreation'), // 返佣活动创建
  rebateActivityManagement: () =>
     import('@/views/distribution/RebateActivityManagement'), // 返佣活动管理
  taoDistributionRebateBill: () =>
     import('@/views/distribution/TaoDistributionRebateBill'), // 淘分销返款账单
  taoDistributionRebateBillDetail: () =>
     import('@/views/distribution/TaoDistributionRebateBillDetail'), // 淘分销返款明细
  tfxActivityProducts: () => import('@/views/distribution/tfxActivityProducts'), // 淘分销选择商品
  activeSetList: () => import('@/views/distribution/ActiveSetList'), // 活动设置列表
  activeDisplayPage: () => import('@/views/distribution/ActiveDisplayPage'), // 活动展示页
  sellerRelationDetail: () =>
     import('@/views/distribution/SellerRelationDetail'), // 业务员关系详情
  createFxOrder: () => import('@/views/distribution/CreateFxOrder'), // 分销下单手工建单
  viewFxOrder: () => import('@/views/distribution/ViewFxOrder'), // 分销下单查看建单
  brandActiveList: () => import('@/views/distribution/BrandActiveList'), // 品牌活动管理
  distributionManagementBlacklist: () =>
     import('@/views/distribution/DistributionManagementBlacklist'), // 黑名单列表
  sellerListNew: () => import('@/views/distribution/SellerListNew'), // 分销平台客户一览（新）
  addSellerListNew: () => import('@/views/distribution/AddSellerListNew'), // 新增分销客户一览(新)信息
  sellerListNewDetail: () => import('@/views/distribution/SellerListNewDetail'), // 分销平台客户一览(详情)信息
  multipleImportOrder: () => import('@/views/distribution/MultipleImportOrder'), // 分销下单批量导单
  storeWarehouseLogisticsRelationship: () => import('@/views/distribution/StoreWarehouseLogisticsRelationship'), // 店铺仓库物流关系配置
  distributionRefundTableList: () => import('@/views/distribution/DistributionRefund/DistributionRefundTableList'), // 处理客商主体预存款列表
  createDistributionRefund: () => import('@/views/distribution/DistributionRefund/CreateDistributionRefund'), // 创建分销退款
  viewDistributionRefundDetail: () => import('@/views/distribution/DistributionRefund/ViewDistributionRefundDetail'), // 分销退款详情
  distributionStatementTableList: () => import('@/views/distribution/DistributionStatement/DistributionStatementTableList'), // 分销对账单列表
  createDistributionStatement: () => import('@/views/distribution/DistributionStatement/CreateDistributionStatement'), // 创建分销对账信息
  viewDistributionStatementDetail: () => import('@/views/distribution/DistributionStatement/ViewDistributionStatementDetail'), // 分销对账详情
  distributionOrderListTableList: () => import('@/views/distribution/DistributionOrderList/DistributionOrderListTableList'), // 分销订单列表
  invoiceApplication: () => import('@/views/distribution/DistributionOrderList/InvoiceApplication'), // 开票申请
  invoicingApplicationTableList: () => import('@/views/distribution/DistributionInvoicingApplication/InvoicingApplicationTableList'), // 开票申请列表
  viewInvoicingApplicationDetail: () => import('@/views/distribution/DistributionInvoicingApplication/ViewInvoicingApplicationDetail'), // 开票申请详情
  createInvoicingApplication: () => import('@/views/distribution/DistributionInvoicingApplication/CreateInvoicingApplication'), // 开票申请编辑
  invoiceListRedTableList: () => import('@/views/distribution/InvoiceListRed/InvoiceListRedTableList'), // 发票列表
  viewInvoiceListRedDetail: () => import('@/views/distribution/InvoiceListRed/ViewInvoiceListRedDetail'), // 发票详情
  createInvoiceListRed: () => import('@/views/distribution/InvoiceListRed/CreateInvoiceListRed'), // 红冲，作废发票
  categoryBoxTableList: () => import('@/views/distribution/CategoryBox/CategoryBoxTableList'), // 类目箱规列表
  createCategoryBox: () => import('@/views/distribution/CategoryBox/CreateCategoryBox'), //  新增类目箱规
  viewCategoryBoxDetail: () => import('@/views/distribution/CategoryBox/ViewCategoryBoxDetail'), //  类目箱规详情
  fCSStatementTableList: () => import('@/views/distribution/FCSStatement/FCSStatementTableList'), // FCS对账单
  viewFCSStatementDetail: () => import('@/views/distribution/FCSStatement/ViewFCSStatementDetail'), // FCS对账单详情
  fCSAccountReceivableTableList: () => import('@/views/distribution/FCSAccountReceivable/FCSAccountReceivableTableList'), // FCS应收单列表
  viewFCSAccountReceivableDetail: () => import('@/views/distribution/FCSAccountReceivable/ViewFCSAccountReceivableDetail'), // FCS应收单详情
  ReturnPartialRedemptionDetails: () => import('@/views/distribution/InvoiceListRed/CreateReturnPartialRedemptionDetails') // 退货部分红冲
}

export default map
